/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type BbDocsDestroyRequest = {} | null | undefined;
export type BbDocsDestroyResponse = any;

export type BbDocsDestroyQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * DELETE /dmx-server/bb_docs/{id}/
 *
 * ```yaml
 * operationId: bb_docs_destroy
 * tags:
 *   - bb_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const bbDocsDestroyOperation = ({ id, ...rest }: BbDocsDestroyQuery) =>
  ({
    method: 'DELETE',
    path: `/dmx-server/bb_docs/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'DELETE';
    path: string & { _templateUrl: '/dmx-server/bb_docs/{id}/' };
  };

/**
 * DELETE /dmx-server/bb_docs/{id}/
 *
 * ```yaml
 * operationId: bb_docs_destroy
 * tags:
 *   - bb_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const bbDocsDestroy = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: BbDocsDestroyQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = bbDocsDestroyOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'DELETE',
    request,
    onUploadProgress,
    cancelToken,
  );
};
